export interface PartnerSalon {
  readonly city: string;
  readonly address: string;
}

export interface PartnerInfo {
  readonly id: string;
  readonly name: string;
  readonly logoSrc: string;
  readonly url: string;
  readonly accentColor: string;
  readonly urlParams: Record<string, string>;
  readonly urlByCountry: Record<string, string>;
  readonly salons: ReadonlyArray<PartnerSalon>;
}

export const SEJFY_PARTNER: PartnerInfo = {
  id: 'sejfy',
  name: 'sejfy.pl',
  logoSrc: 'assets/partners/sejfypl-logo.svg',
  url: 'https://bestsafes.eu',
  accentColor: '#2198d5',
  urlParams: {},
  urlByCountry: {
    PL: 'https://sejfy.pl',
    AT: 'https://bestsafes.at',
    BE: 'https://bestsafes.be',
    BG: 'https://bestsafes.bg',
    CH: 'https://bestsafes.ch',
    CY: 'https://bestsafes.cy',
    CZ: 'https://bestsafes.cz',
    DE: 'https://bestsafes.de',
    DK: 'https://bestsafes.dk',
    EE: 'https://bestsafes.ee',
    ES: 'https://bestsafes.es',
    FI: 'https://bestsafes.fi',
    FR: 'https://bestsafes.fr',
    HR: 'https://bestsafes.hr',
    HU: 'https://bestsafes.hu',
    IE: 'https://bestsafes.ie',
    IT: 'https://bestsafes.it',
    LT: 'https://bestsafes.lt',
    LV: 'https://bestsafes.lv',
    LU: 'https://bestsafes.lu',
    NL: 'https://bestsafes.nl',
    NO: 'https://bestsafes.no',
    PT: 'https://bestsafes.pt',
    RO: 'https://bestsafes.ro',
    SE: 'https://bestsafes.se',
    SI: 'https://bestsafes.si',
    SK: 'https://bestsafes.sk',
    GB: 'https://bestsafes.uk'
  },
  salons: [
    { city: 'Warszawa', address: 'ul. Orla 8, 00-143' },
    { city: 'Wypędy', address: 'ul. Sokołowska 43, 05-090' },
    { city: 'Wrocław', address: 'Al. Hallera 182/1, 53-203' },
    { city: 'Łódź', address: 'ul. Inflancka 1/3, 91-857' },
    { city: 'Kraków', address: 'ul. Zakopiańska 56a, 30-418' },
    { city: 'Gdańsk', address: 'Al. Grunwaldzka 489, 80-309' },
    { city: 'Katowice', address: 'Al. Wojciecha Korfantego 51, 40-160' },
    { city: 'Poznań', address: 'Al. Bałtycka 40, 61-016' }
  ]
};
